import { useEffect } from 'react';

/**
 * Sets `document.title` while the calling component is mounted and restores
 * the previous title on unmount. Use at the top of every top-level page
 * component so users with multiple tabs can tell pages apart in the tab strip.
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
